import { useState } from "react";
import { Col } from "@/utils/bootstrap";
import ClearCartModal from "../../../ClearCartModal";
import SvgMinus from "./SvgMinus";
import SvgPlus from "./SvgPlus";
import SvgRecycleBin from "./SvgRecycleBin";
import ExpandingQuantityInput from "@/app/components/common-builder/product/product-box/product-box-helpers/btn-expanding-add-to-card/btn-esxpanding-types/ExpandingQuantityInput";

interface Props {
  cartItemId: number;
  quantity: number;
  setQuantity: (count: number) => void;
  plusDisabled: boolean;
  min_quantity_in_cart: number | null;
}
const ItemQuantityBtn: React.FC<Props> = ({
  quantity,
  setQuantity,
  cartItemId,
  plusDisabled,
  min_quantity_in_cart,
}) => {
  const [show, setShow] = useState(false);
  const minQuantity = min_quantity_in_cart ?? 1;
  return (
    <>
      <ClearCartModal show={show} setShow={setShow} id={cartItemId} />
      <div dir="ltr">
        <div className="d-flex align-items-center btn-cart-itemm-quantity-selector-counter">
          <Col className="col-auto px-2">
            <SvgPlus
              onClick={() => setQuantity(quantity + 1)}
              disabled={plusDisabled}
            />
          </Col>
          <Col className="col-auto col-auto px-2">
            <ExpandingQuantityInput
              quantity={quantity}
              setQuantity={(quantity) => {
                if (quantity === 0) {
                  setShow(true);
                  return;
                }
                setQuantity(quantity);
              }}
            />
          </Col>
          <Col className="col-auto col-auto px-2">
            {quantity > minQuantity && (
              <SvgMinus onClick={() => setQuantity(quantity - 1)} />
            )}
          </Col>
          <Col className="col-auto col-auto px-2">
            <SvgRecycleBin onClick={() => setShow(true)} />
          </Col>
        </div>
      </div>
    </>
  );
};

export default ItemQuantityBtn;
